module.exports = __webpack_public_path__ + "static/media/healables.b2156330.png";